import React from 'react';
import { createRoot } from 'react-dom/client';

import BoutiqueForm from './controllers/BoutiqueForm';
import ProductForm from './controllers/ProductForm';

const components = {
    BoutiqueForm,
    ProductForm,
};

document.addEventListener('DOMContentLoaded', () => {
    // Support des attributs personnalisés et de Symfony UX React
    const elements = document.querySelectorAll('[data-react-component], [data-symfony--ux-react--react-component-value]');

    elements.forEach(el => {
        const componentName = el.getAttribute('data-react-component') || el.getAttribute('data-symfony--ux-react--react-component-value');
        const Component = components[componentName];
        
        if (Component) {
            const propsJson = el.getAttribute('data-react-props') || el.getAttribute('data-symfony--ux-react--react-props-value') || '{}';
            try {
                const props = JSON.parse(propsJson);
                const root = createRoot(el);
                root.render(<Component {...props} />);
            } catch (e) {
                console.error(`Erreur lors du rendu de ${componentName}:`, e);
            }
        }
    });
});
